import { createSlice } from "@reduxjs/toolkit";

export const networkSlice = createSlice({
    name: 'address',
    initialState: {
        data: {},
    },
    reducers: {
        setNetwork: (state, {payload : data}) => {
            state.data = data
        },
        getNetwork: (state, action) => {
            state.data = action.payload
        },
    },
});

export const { setNetwork, getNetwork } = networkSlice.actions;

export default networkSlice.reducer;